import { AB_WAREHOUSE_MAP, SM_WAREHOUSE_MAP } from "./parseInventoryData";

/*
    Create singular object for items body param in cart API calls.
*/
export const createCartEntry = (
  vendorCode,
  selectedWhse,
  itemQuantity,
  itemPrice,
  item = null,
  updatingEntry = true,
  itemNumber = null, // need this for adding items in the inventory table
  inventoryEntry = null,
) => {
  const definedItemNumber =
    item && item?.itemNumber ? item?.itemNumber : itemNumber;

  // Calculate total price if itemPrice is available
  const totalPrice = itemPrice
    ? parseFloat(itemPrice.toString().replace(/[^0-9.]/g, "")) *
      parseFloat(itemQuantity)
    : null;

  let entry;
  switch (vendorCode) {
    case "ab":
      entry = createABEntry(selectedWhse, itemQuantity, definedItemNumber);
      break;
    case "cm":
      entry = createCMEntry(itemQuantity, definedItemNumber, selectedWhse);
      break;
    case "sm":
      entry = createSMEntry(
        definedItemNumber,
        itemQuantity,
        selectedWhse,
        updatingEntry,
      );
      break;
    case "as":
      const asItemNumber =
        item && Object.keys(item).length > 0 && item.id ? item.id : itemNumber;
      entry = createASEntry(asItemNumber, itemQuantity, updatingEntry);
      break;
    case "acc":
      entry = {
        itemNumber: definedItemNumber,
        qty: itemQuantity,
        warehouse: selectedWhse,
      };
      break;
    case "pg":
      entry = createPGEntry(
        definedItemNumber,
        itemQuantity,
        updatingEntry,
        item,
      );
      break;
    case "asc":
      // TODO does this work on the cart page?
      entry = createASCEntry(
        definedItemNumber,
        itemQuantity,
        selectedWhse,
        updatingEntry,
        item,
        inventoryEntry,
      );
      break;
    case "slc":
      entry = createSLCEntry(
        definedItemNumber,
        itemQuantity,
        selectedWhse,
        updatingEntry,
        item,
      );
      break;
    case "sta":
      // Staton is default fdm4 payload
      entry = {
        itemNumber: definedItemNumber,
        qty: itemQuantity,
        warehouse: selectedWhse,
      };
      break;
    case "ss":
      entry = createDirectEntry(
        item?.dgi_style_sku,
        definedItemNumber,
        vendorCode || item?.vendorCode,
        item?.warehouseCode,
        itemPrice || item?.unitPrice,
        itemQuantity,
        item?.master_color,
        updatingEntry,
        item,
      );
      break;
    default: // direct vendors route here
      console.log("Creating direct entry");
      console.log(item);
      entry = createDirectEntry(
        item?.dgi_style_sku,
        definedItemNumber,
        vendorCode || item?.vendorCode,
        selectedWhse,
        itemPrice || item?.unitPrice,
        itemQuantity,
        item?.master_color,
        updatingEntry,
      );
  }

  // Add total_quantity and total_price to all cart entries for analytics
  entry.total_quantity = parseFloat(itemQuantity);
  if (totalPrice !== null) {
    entry.total_price = totalPrice;
  }

  return entry;
};

const createDirectEntry = (
  dgi_style_sku,
  itemNumber,
  vendor,
  warehouse,
  unitPrice,
  itemQuantity,
  masterColor,
  updatingEntry,
  item = null,
) => {
  const strippedPrice =
    typeof unitPrice === "string" ? unitPrice.replace("$", "") : unitPrice;
  return {
    dgi_style_sku: dgi_style_sku,
    itemNumber: itemNumber,
    direct_vendor: vendor,
    warehouse: item?.warehouse || warehouse,
    warehouseCode: item?.warehouseCode,
    warehouseName: item?.warehouseName,
    unitPrice: strippedPrice,
    quantity: itemQuantity,
    updatingEntry: updatingEntry,
    master_color: masterColor,
    size: item?.size,
    style: item?.style,
    product_image_url: item?.product_image_url,
    colorDesc: item?.colorDesc,
  };
};

const createSLCEntry = (
  itemNumber,
  itemQuantity,
  selectedWhse,
  updatingEntry,
  item,
) => {
  if (updatingEntry) {
    return {
      sku: itemNumber,
      quantity: itemQuantity,
      warehouseCode: item?.warehouseCode,
      itemId: item?.id,
      uid: item?.uid,
    };
  }
  return {
    sku: itemNumber,
    quantity: itemQuantity.toString(),
    warehouseCode: selectedWhse,
    Add: true,
  };
};

const createASCEntry = (
  itemNumber,
  itemQuantity,
  selectedWhse,
  updatingEntry,
  item,
  inventoryEntry,
) => {
  if (updatingEntry) {
    return {
      itemNumber: itemNumber,
      quantity: itemQuantity,
      warehouseCode: selectedWhse,
      itemId: item?.id,
      asc_product_id: item?.asc_product_id,
      variant_id: item?.variant_id,
    };
  }
  return {
    asc_product_id: item?.asc_product_id,
    itemNumber: itemNumber,
    quantity: itemQuantity.toString(),
    warehouseCode: selectedWhse,
    variant_id: inventoryEntry?.variant_id,
  };
};

const createABEntry = (selectedWhse, itemQuantity, itemNumber) => {
  return {
    itemNumber: itemNumber,
    qty: itemQuantity,
    warehouse: selectedWhse,
    prodType: "blank",
  };
};

const createCMEntry = (itemQuantity, itemNumber, warehouse) => {
  if (warehouse === "Indian Trail, NC") {
    warehouse = "NC";
  }
  return {
    itemNumber: itemNumber,
    qty: itemQuantity,
    warehouse: warehouse,
  };
};

const createSMEntry = (
  itemNumber,
  itemQuantity,
  selectedWhse,
  updatingEntry,
) => {
  return {
    product: { code: itemNumber },
    warehouseCode: selectedWhse.toString(),
    quantity: itemQuantity,
    updatingEntry: updatingEntry,
  };
};

const createASEntry = (itemNumber, itemQuantity, updatingEntry) => {
  if (updatingEntry) {
    return {
      orderItemId: itemNumber.toString(),
      quantity: itemQuantity,
    };
  } else {
    return {
      catEntryId: itemNumber.toString(),
      quantity: itemQuantity.toString(),
    };
  }
};

function createPGEntry(itemNumber, qty, updatingEntry, item) {
  if (updatingEntry) {
    return {
      itemNumber: itemNumber,
      qty: Number(qty),
      odidlist: item?.odidlist,
    };
  } else {
    return {
      itemNumber: itemNumber,
      qty: Number(qty),
      Add: true,
    };
  }
}

export const createSwitchWarehouseBody = (vendorCode, item, warehouse) => {
  switch (vendorCode) {
    case "ab":
      const oldWhse = Object.entries(AB_WAREHOUSE_MAP).find((whse) => {
        const [whseKey, whseName] = whse;
        return item.warehouse === whseName;
      });
      const oldWhseCode = oldWhse && oldWhse[0];
      return {
        items: [
          {
            itemNumber: item.itemNumber,
            qty: "0",
            warehouse: oldWhseCode,
            prodType: "blank",
          },
          {
            itemNumber: item.itemNumber,
            qty: item.quantity.toString(),
            warehouse: warehouse.code,
            prodType: "blank",
          },
        ],
      };
    case "cm":
      return {
        items: [
          {
            itemNumber: item.itemNumber,
            qty: "0",
            warehouse: item.warehouseCode || item.warehouse,
          },
          {
            itemNumber: item.itemNumber,
            qty: item.quantity.toString(),
            warehouse: warehouse.code,
          },
        ],
      };
    case "sm":
      const oldSMWhse = Object.entries(SM_WAREHOUSE_MAP).find(
        ([whseKey, whseName]) => {
          const normalizedItemWarehouse = item.warehouse.trim().toLowerCase();
          const normalizedWhseName = whseName.trim().toLowerCase();
          return normalizedItemWarehouse === normalizedWhseName;
        },
      );
      const oldSMWhseCode = oldSMWhse ? oldSMWhse[0] : null;
      return {
        items: [
          {
            product: { code: item.itemNumber },
            warehouseCode: oldSMWhseCode,
            quantity: "0",
            updatingWarehouse: true,
          },
          {
            product: { code: item.itemNumber },
            warehouseCode: warehouse.code.toString(),
            quantity: item.quantity.toString(),
            updatingWarehouse: true,
          },
        ],
      };
    case "ss":
      // Build the base item with all required fields
      const baseItem = {
        direct_vendor: "ss",
        dgi_style_sku: item.dgi_style_sku,
        vendorCode: "ss",
        itemNumber: item.itemNumber,
        master_color: item.master_color,
        size: item.size,
        sizeLabel: item.sizeLabel,
        gtin: item.gtin,
        unitPrice: item.unitPrice,
        updatingEntry: false,
        product_url_short: item.product_url_short,
        product_image_url: item.product_image_url,
      };
      return {
        items: [
          {
            ...baseItem,
            warehouse: item.warehouse, // old warehouse name
            warehouseCode: item.warehouseCode,
            quantity: "0",
          },
          {
            ...baseItem,
            warehouse: warehouse.name, // new warehouse name
            warehouseCode: warehouse.code,
            quantity: item.quantity,
          },
        ],
      };
    default:
      return null;
  }
};
